/** Limites métier partagées : le front les utilise pour l'UX, l'API pour la validation. */
export const LIMITS = {
  noteTitle: 1_000,
  noteContent: 20_000,
  checklistItems: 1_000,
  checklistItemText: 2_000,
  labelName: 50,
  labelsPerUser: 500,
  userName: 80,
  passwordMin: 8,
  passwordMax: 128,
  attachmentBytes: 10 * 1024 * 1024,
  attachmentsPerNote: 20,
  bulkIds: 500,
  searchQuery: 200,
  /** Notes par requête d'import (le client découpe l'import en lots). */
  importBatch: 50,
} as const;

/** Durée de conservation des notes dans la corbeille avant suppression définitive. */
export const TRASH_RETENTION_DAYS = 7;

export const ALLOWED_ATTACHMENT_MIME_TYPES = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
] as const;
